import { render, staticRenderFns } from "./joinService.vue?vue&type=template&id=fa075278&scoped=true"
import script from "./joinService.vue?vue&type=script&lang=js"
export * from "./joinService.vue?vue&type=script&lang=js"
import style0 from "./joinService.vue?vue&type=style&index=0&id=fa075278&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa075278",
  null
  
)

export default component.exports